import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ArcgisInterceptor } from './arcgis-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ArcgisInterceptor, multi: true },
];

export { ArcGisTokenGuard } from './arcgisToken.guard';

export { AppSettingsGuard } from './appSettings.guard';
